import React, { useEffect, useState } from "react";

import moment from "moment/moment";
import axiosInstance from "../../../axios";
import { Loading } from "../../Other/Loading";


const UpcomingWebinar = () => {
  const [webinar, setWebinar] = useState([]);
  const now = new Date();

  const firstDay = moment(
    new Date(now.getFullYear(), now.getMonth(), 1)
  ).format("YYYY MM,DD");
  const lastDay = moment(
    new Date(now.getFullYear(), now.getMonth() + 1, 0)
  ).format("YYYY MM,DD");
  useEffect(() => {
    axiosInstance
      .get(`webinar/all?startDate=${firstDay}&endDate=${lastDay}`)
      .then((response) => {
        setWebinar(response.data.data);
      })
      .catch((err) => console.log(err));
  }, []);

  function eventsGetDays() {
    var startDate = moment(now).format("YYYY,MM,DD");
    const webinardata = webinar?.map((ele, items) => {
      var endDate = moment(ele?.webinarDate, "YYYY,MM,DD");
      var result = endDate.diff(startDate, "days");
      return { ...ele, result };
    });
    return webinardata;
  }

  const webinardata = eventsGetDays();

  return (
    <div className="box-shadow-new-01">
      <p className="paragraph-css">Today's or Upcoming Webinar</p>

      <div>
        {webinar.length === 0 ? (
          <Loading />
        ) : (
          <>
            {webinardata?.map((item, index) => (
              <div key={index} className="webinar-box">
                <p className="webinar-text">{item?.eventName}</p>
                <div className="dashboard-main align-items-center-webinar">
                  <span className="icon icon-reminder width-icons-instructor"></span>
                  <span className="webinar-timing">
                    {item.result} Days Left
                  </span>
                </div>
                <div className="dashboard-main align-items-center-webinar">
                  <span className="icon icon-calendar width-icons-instructor"></span>
                  <div className="dashboard-main align-items-center-webinar">
                    <p className="webinar-timing">
                      {moment(item?.webinarDate).format("DD/MM/YYYY")}
                    </p>
                    <span>|</span>
                    <p className="webinar-timing">{item?.startTime}</p>
                  </div>
                </div>
                <div className="dashboard-main align-items-center-webinar">
                  <span className="icon icon-calendar width-icons-instructor"></span>
                  <p className="webinar-timing">20</p>
                </div>

                <button className="export-btn">Join</button>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default UpcomingWebinar;
